import { Button } from "../components/ui/button";

const ConsultationOffer = () => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-r from-red-900 to-red-800">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-6 md:space-y-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            Ready to Take the Next Step?
          </h2>
          <p className="text-white">Marriage is a lifelong commitment—make sure you start on the right path. Order your <strong>Premium Kundli Matching Report</strong> now to gain deep insight into your relationship and set the foundation for a joyful future together.</p>
          

          <Button
            variant="astrology"
            size="xl"
            className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold px-6 md:px-8 py-3 md:py-4 text-base md:text-lg w-full sm:w-auto"
            onClick={() => {
              const pricingSection = document.querySelector('[data-section="pricing"]');
              if (pricingSection) {
                pricingSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            Act now to secure your discounted rate of ₹1050!
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ConsultationOffer;
